import React, { Component } from 'react';
import { TimelineLite, TweenLite, Linear } from 'gsap';
import { CSSPlugin } from 'gsap/CSSPlugin';
import PlayPauseButton from '../ui/PlayPauseButton';

import styles from './AutoAdvancer.module.scss';

const plugins = [CSSPlugin];
class AutoAdvancer extends Component {
  state = {
    isPlaying: true,
  };

  renderDots = (totalSlides, currentSlide) => {
    const dots = [];
    for (let index = 0; index < totalSlides; index++) {
      dots.push(
        <div
          id={`dot-${index}`}
          key={`dot-${index}`}
          className={`${styles.dot} ${
            currentSlide === index && !this.props.isTransitioning
              ? styles.active
              : ''
          }`}
          onClick={() => {
            this.props.anySlide(index);
          }}
        >
          <div className={styles.outerDot} />
          <div className={styles.innerDot} />
        </div>
      );
    }
    return dots;
  };

  createAnimation = foreground => {
    if (this.tween) return;

    this.foregroundRef = foreground;

    TweenLite.set(foreground, { scaleX: 0 });

    this.tween = TweenLite.to(foreground, 14, {
      scaleX: 1,
      paused: true,
      onComplete: () => {
        this.props.currentIndex === this.props.totalSlides - 1
          ? this.props.anySlide(0)
          : this.props.nextSlide();
        this.pause(true);
      },
      ease: Linear.easeNone,
    });

    if (!this.props.waitingForLoad) this.play(true);
  };

  play = (restart = false) => {
    this.setState(
      {
        isPlaying: true,
      },
      () => (restart ? this.tween.play(0) : this.tween.play())
    );
  };

  pause = (restart = false) => {
    this.setState(
      {
        isPlaying: false,
      },
      () => (restart ? this.tween.pause(0) : this.tween.pause())
    );
  };

  handlePlayPause = () => (this.state.isPlaying ? this.pause() : this.play());

  componentDidUpdate(prevProps) {
    if (this.props.currentIndex !== prevProps.currentIndex) {
      this.play(true);
    }
    if (
      this.props.waitingForLoad !== prevProps.waitingForLoad &&
      !this.props.waitingForLoad
    ) {
      this.play(true);
    }
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeypress);
    if (this.props.registerPause) {
      this.props.registerPause(this.pause);
    }
  }

  componentWillUnmount() {
    TweenLite.killTweensOf(this.foregroundRef);
    if (this.tween && this.tween.kill) {
      this.tween.kill();
    }
    window.removeEventListener('keypress', this.handleKeypress);
  }
  // Pause on spacebar press... I found myself trying to do this subconciously
  handleKeypress = e => {
    if (e.keyCode == 32) {
      if (this.state.isPlaying) {
        this.pause();
      } else {
        this.play();
      }
    }
  };
  render() {
    return (
      <div
        className={`${styles.container} ${
          this.props.exited ? styles.exited : ''
        }`}
      >
        <div className={styles.dotContainer}>
          {this.renderDots(this.props.totalSlides, this.props.currentIndex)}
        </div>
        <div
          className={`${this.props.isHome ? styles.isHome : ''} ${
            styles.buttonContainer
          }`}
        >
          <PlayPauseButton
            noBackground
            colorTheme={this.props.colorTheme}
            isPaused={!this.state.isPlaying}
            onPlayPauseClick={
              this.state.isPlaying
                ? this.pause.bind(null, false)
                : this.play.bind(null, false)
            }
          />
        </div>
        <div className={styles.progressBar}>
          <div className={styles.background} />
          <div
            className={`${styles.foreground} ${
              styles['color-' + this.props.colorTheme]
            }`}
            ref={this.createAnimation}
          />
        </div>
      </div>
    );
  }
}

export default AutoAdvancer;



// WEBPACK FOOTER //
// ./src/components/ui/AutoAdvancer.js